import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import forEach from 'lodash/forEach'
import words from 'lodash/words'
import head from 'lodash/head'
import includes from 'lodash/includes'
import EventBus from 'components/helpers/event-bus'

export default {
  mounted() {
    const self = this
    // init photos overlay
    if (get(self, 'getBodyOptions.photoOverlay', false)) {
      // get image element from body
      const fetchPhotos = []
      if (!isEmpty(self.node.images)) {
        let attrTitle = ''
        forEach(self.$refs.articleBody.querySelectorAll('.article-body img'), (v) => {
          if (!includes(v.classList, 'disable-photoslider')) {
            attrTitle = v.getAttribute('title') || ''
            // [tmp-src] quick fix for photo slider
            let imgSrc = v.parentNode.className.match(/colorbox/i) ? words(v.parentNode.getAttribute('href'), /\/[0-9]{4}\/[0-9]{2}\/[0-9]{2}\/.*?\.(jpg|jpeg|png|gif)/i) :
              words(v.getAttribute('tmp-src'), /\/[0-9]{4}\/[0-9]{2}\/[0-9]{2}\/.*?\.(jpg|jpeg|png|gif)/i)
            imgSrc = head(imgSrc) || false
            if (imgSrc) {
              forEach(self.node.images, (images) => {
                let image = words(images.style_1320w, /\/[0-9]{4}\/[0-9]{2}\/[0-9]{2}\/.*?\.(jpg|jpeg|png|gif)/i)
                image = head(image) || false
                if (v.parentNode.className.match(/colorbox/i) && imgSrc === image) {
                  fetchPhotos.push({title: attrTitle, caption: attrTitle, enlarge: images.style_1320w, el: v})
                } else if (image === imgSrc) {
                  // normal inline photo
                  fetchPhotos.push({title: attrTitle, caption: attrTitle, enlarge: images.style_1320w, el: v})
                }
              })
            }
          }
        })

        if (!isEmpty(fetchPhotos)) {
          forEach(fetchPhotos, (v, i) => {
            v.el.onclick = function (e) {
              e.preventDefault()
              EventBus.$emit('openPhotoSlider', i, false, fetchPhotos, self.node.title)
            }
          })
          const getPhotoFromUrl = get(this, '$route.fullPath').match(/(photo)\/(\d{1,2})\/?/)
          if (getPhotoFromUrl) {
            EventBus.$emit('openPhotoSlider', (parseInt(getPhotoFromUrl[2], 0) - 1), false, fetchPhotos, self.node.title)
          }
        }
      }
    }
  },
}



// WEBPACK FOOTER //
// ./components/mixins/photoSlider.js